module.exports = __webpack_public_path__ + "img/popup2tu1anzhuo.90622e50.png";